import { yup } from '@framework/validation';
import { WidgetType } from '../../../Widget';
import { CommonContainerWidgetConfigSchema } from '../../containers/common/CommonContainerWidgetConfigSchema';
import { ICompanyWidget } from './ICompanyWidget';

export const CompanyWidgetConfigSchema: yup.ObjectSchema<ICompanyWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Company).required(),
  })
    .required()
    .noUnknown();
